var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLockFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2,7.00684547 C2,6.45078007 2.45470893,6 2.9999602,6 L18.0000398,6 C18.5523026,6 19,6.44994876 19,7.00684547 L19,18.9931545 C19,19.5492199 18.5452911,20 18.0000398,20 L2.9999602,20 C2.44769743,20 2,19.5500512 2,18.9931545 L2,7.00684547 Z M9,12.5008327 L9,15 L12,15 L12,12.5008327 C12,11.6785455 11.3284271,11 10.5,11 C9.66579723,11 9,11.6719457 9,12.5008327 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9999999,7 C16,6.99963379 16,6.99926756 16,6.99890133 L16,6.00109867 C16,3.23927286 13.7609319,1 10.9989013,1 L10.0010987,1 C7.23927286,1 5,3.23906814 5,6.00109867 L5,6.99890133 C5,6.99926756 5.00000004,6.99963379 5.00000012,7 L8.00000536,7 C8.00000193,6.9983733 8,6.99674613 8,6.9951185 L8,6.0048815 C8,4.89761602 8.8938998,4 10.0048815,4 L10.9951185,4 C12.102384,4 13,4.8938998 13,6.0048815 L13,6.9951185 C13,6.99674612 12.9999981,6.99837329 12.9999942,7 L15.9999999,7 Z"
})))));
export default SvgLockFill;